module.exports = "<div [@menuState]=\"menuState\" class=\"menu_top-items-wrapper\">\n\t<ng-content></ng-content>\n\tmenuState: {{ menuState }}\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/system/core/side-menu/top-items/top-items.component.html
// module id = ./src/app/system/core/side-menu/top-items/top-items.component.html
// module chunks = main